/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PitchStatistics {
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly highest_gross: string;
  readonly lowest_gross: string;
  readonly avg_gross: string;
  readonly avg_pitch_period: number;
  readonly longest_pitch_period: number;
  readonly shortest_pitch_period: number;
  readonly ct_passed_percentage: number | null;
  readonly pitches_bar_chart: { [key: string]: any };
  readonly total_raised_over_time: { [key: string]: any };
  readonly investments_per_pitch: { [key: string]: any };
  readonly origins: { [key: string]: any };
}
